module.exports = __webpack_public_path__ + "img/u552.c7c52a09.svg";